import { render } from "./RelatorioAnalise.vue?vue&type=template&id=265a38ef"
import script from "./RelatorioAnalise.vue?vue&type=script&lang=js"
export * from "./RelatorioAnalise.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__